import { Environment } from '../utils/environment';

export const GATEWAY_BASE: { dev: string; stageOrProd: string } = {
  dev: 'https://gateway.sunrundev.com',
  stageOrProd: 'https://gateway.sunrun.com',
};

export const PXE_BACKEND_URL = {
  [Environment.LOCAL]: `${GATEWAY_BASE.dev}/devmaj-pxe-backend`,
  [Environment.DEVMAJ]: `${GATEWAY_BASE.dev}/devmaj-pxe-backend`,
  [Environment.MAJSTG]: `${GATEWAY_BASE.stageOrProd}/majstg-pxe-backend`,
  [Environment.PROD]: `${GATEWAY_BASE.stageOrProd}/pxe-backend`,
} as const;

export const PXE_PORTAL_URL = {
  [Environment.LOCAL]: `${GATEWAY_BASE.dev}/devmaj-pxe-portal`,
  [Environment.DEVMAJ]: `${GATEWAY_BASE.dev}/devmaj-pxe-portal`,
  [Environment.MAJSTG]: `${GATEWAY_BASE.stageOrProd}/majstg-pxe-portal`,
  [Environment.PROD]: `${GATEWAY_BASE.stageOrProd}/pxe-portal`,
} as const;

export const PORTAL_AUTH_BASE_URL = {
  local: `${GATEWAY_BASE.stageOrProd}/majstg-portal-auth`,
  devmaj: `${GATEWAY_BASE.stageOrProd}/majstg-portal-auth`,
  majstg: `${GATEWAY_BASE.stageOrProd}/majstg-portal-auth`,
  prd: `${GATEWAY_BASE.stageOrProd}/portal-auth`,
} as const;
